/** Тексты экрана Milanuncios (ES). */
export const milanunciosCopy = {
  searchPlaceholder: 'Busca en milanuncios.es',
  tabParticular: 'Particular',
  tabEmpresa: 'Empresa',
  step1: 'Primer paso',
  step2: 'Segundo paso',
  step3: 'Tercer paso',
  step4: 'Complete',
  shouldKnowTitle: 'Deberías saber',
  shouldKnowP1: 'Disponemos de embalajes isotermos que garantizan la temperatura en rango durante 5 días.',
  shouldKnowP2:
    'Milanuncios monitoriza y controla la temperatura, la humedad y los golpes de todos los envíos de Milanuncios Frío que se transportan a través de nuestra red. Los clientes con contrato además podrán realizar la monitorización de sus envíos.',
  shouldKnowP3:
    'Las cajas o embalajes que utilizamos cumplen con la certificación ISTA que acredita el cumplimiento de los estándares necesarios.',
  shouldKnowP4:
    'Las cajas o embalajes que se utilizan para la prestación del servicio son reutilizados dentro del circuito logístico de Milanuncios, aseguramos el mantenimiento de los mismos y la calidad del servicio a la vez que apostamos por un consumo y una gestión sostenible.',
  sellerLabel: '* Vendedor',
  priceLabel: '* Precio',
  fieldNombre: 'Nombre',
  fieldSegundoNombre: 'Segundo Nombre',
  fieldApellido: 'Apellido',
  fieldDob: 'Fecha de nacimiento',
  fieldDobPlaceholder: '12.04.2026',
  fieldDireccion: 'Dirección',
  fieldCiudad: 'Ciudad / Suburbio / Pueblo',
  fieldEstado: 'Estado / Provincia',
  fieldPhone: 'Ingrese su número telefónico',
  fieldCp: 'Código Postal',
  payCta: 'Pagar',
  bullet1: '* Transacciones 100% seguras',
  bullet2: '* Seguimiento del envío',
  bullet3: '* Devolución gratuita',
};
